/**
 * خروجی فاکتورها با هدرهای سازگار با ایمپورت همگانی (SC_HEADERS / parse_universal).
 * ترجیح: Excel از بک‌اند؛ CSV به‌عنوان پشتیبان با تاریخ شمسی لاتین.
 */
import { isoToJalaali } from "./dateUtils";
import { scExportEventsForImport } from "../api/client";

// برچسب‌هایی که _UNIVERSAL_TYPE_MAP / SC_MOVES می‌شناسد
const EVENT_TO_IMPORT_LABEL = {
  yarn_purchased: "خرید نخ (درین)",
  yarn_sent_to_knitter: "خرید نخ (درین)",
  raw_fabric_produced: "خروجی بافت (نوربخش/خوشباف)",
  raw_fabric_sent_to_dyeing: "خروجی بافت (نوربخش/خوشباف)",
  dyed_fabric_received_from_dyeing: "خروجی رنگرزی",
  dyed_fabric_received_in_gharchak_warehouse: "ورود به انبار قرچک",
  waste_registered: "ضایعات",
  adjustment: "اصلاحیه",
  opening_balance: "اصلاحیه",
};

export const SC_IMPORT_HEADERS = [
  "نوع حرکت",
  "تاریخ (شمسی)",
  "نوع پارچه/کالا",
  "رنگ",
  "وزن (kg)",
  "طاقه",
  "عرض (م)",
  "کارتن",
  "پالت",
  "فی",
  "مبلغ کل",
  "شماره فاکتور",
  "شماره سفارش",
  "شماره سند/مجوز",
  "توضیحات",
];

/** تاریخ شمسی با ارقام لاتین YYYY/MM/DD — همان قالب نمونه‌های ایمپورت */
function jalaliSlash(iso) {
  const p = isoToJalaali(iso);
  if (!p) return "";
  return `${p.jy}/${String(p.jm).padStart(2, "0")}/${String(p.jd).padStart(2, "0")}`;
}

function roundRial(v) {
  if (v == null || v === "") return "";
  const n = Number(v);
  return Number.isFinite(n) ? String(Math.round(n)) : "";
}

function rowToImportCells(r) {
  const move = EVENT_TO_IMPORT_LABEL[r.event_type] || "";
  const fabric = r.fabric_type || r.yarn_type || r.item_name || "";
  const permit = r.permit_number || r.external_document_number || "";
  const noteParts = [];
  if (r.notes) noteParts.push(String(r.notes));
  if (r.source_party_name) noteParts.push(`مبدأ: ${r.source_party_name}`);
  if (r.destination_party_name) noteParts.push(`مقصد: ${r.destination_party_name}`);
  return [
    move,
    jalaliSlash(r.event_date),
    fabric,
    r.color || "",
    r.weight_kg != null ? String(r.weight_kg) : "",
    r.roll_count != null ? String(r.roll_count) : "",
    r.width_m != null ? String(r.width_m) : "",
    r.carton_count != null ? String(r.carton_count) : "",
    r.pallet_count != null ? String(r.pallet_count) : "",
    roundRial(r.unit_price),
    roundRial(r.total_amount),
    r.external_invoice_number || "",
    r.order_code || "",
    permit,
    noteParts.join(" | "),
  ];
}

function csvEscape(s) {
  const v = String(s ?? "");
  return /[",\n\r]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
}

/** دانلود CSV سازگار با ایمپورت همگانی (پشتیبان) */
export function exportEventsImportCsv(rows, filename) {
  const body = (rows || []).map(rowToImportCells);
  const lines = [SC_IMPORT_HEADERS, ...body].map((row) => row.map(csvEscape).join(",")).join("\r\n");
  const blob = new Blob(["\uFEFF" + lines], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || `gharchak-events-import-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * دانلود Excel استاندارد همگانی از بک‌اند (قابل ورود مستقیم در مرکز ایمپورت).
 * اگر API در دسترس نباشد → CSV (مرکز ایمپورت CSV را هم می‌پذیرد).
 * @returns {"xlsx"|"csv"}
 */
export async function exportEventsForImport(rows) {
  const ids = (rows || []).map((r) => r.id).filter((id) => id != null);
  if (!ids.length) {
    throw new Error("ردیفی برای خروجی نیست");
  }
  try {
    await scExportEventsForImport(ids);
    return "xlsx";
  } catch {
    exportEventsImportCsv(rows);
    return "csv";
  }
}
